import makeAjaxRequest from 'helpers/makeAjaxRequest';
import { formatMyTaskData, transformBool } from 'helpers/utils';
import * as R from 'ramda';

import {
  CALL_PASS_THROUGH,
  FETCH_LMS_TRAINING_DATA,
  FETCH_MY_TASKS,
  FETCH_PERSON_ADDRESSES_DATA,
  FETCH_PERSON_AFFILIATIONS,
  FETCH_PERSON_ATTRIBUTES,
  FETCH_PERSON_CONTACTS_DATA,
  FETCH_PERSON_REGISTRATION_DATA,
  FETCH_PERSON_ROSTER_ROLE_DATA,
  FETCH_PERSON_SUMMARY,
  SAVE_SELECTED_MEMBER_ROLE_STATUS,
  SAVE_SELECTED_MEMBER_ROSTER_STATUS,
  SAVE_SELECTED_PERSON_DATA,
  SET_SELECTED,
  UPDATE_USER_GROUP
} from '../types';

const { REACT_APP_ORIGIN, REACT_APP_PERSON_API_VERSION } = process.env;
const personDataService = `${REACT_APP_ORIGIN}person-data-service/${REACT_APP_PERSON_API_VERSION}`;
const passThroughURL = `${process.env.REACT_APP_ORIGIN}core-service/system/core/passthrough`;

const sortByFirstItem = R.sortBy(R.prop('courseName'));

function addPersonInfoToData(d, selectedPerson) {
  const { data, meta } = d;
  if (Array.isArray(data) && selectedPerson) {
    const addressDto = selectedPerson?.addressDto?.filter(
      (add) => add.infoSource === 'CTEP' && add.addressType === 'Office'
    );
    const add = R.head(addressDto || {});
    const mergeData = data.map((x) => ({
      email: selectedPerson.emailId,
      phone: selectedPerson.office_phone,
      address: add?.address,
      ...x
    }));
    const a = { data: mergeData, meta };
    return a;
  }
  return d;
}
export const setSelected = (value, index) => (dispatch) => {
  dispatch({
    type: SET_SELECTED,
    payload: Promise.resolve({
      value,
      index
    })
  });
};

export const fetchPersonsRegistrationData = (ctsuId) => async (dispatch) => {
  dispatch({
    type: FETCH_PERSON_REGISTRATION_DATA,
    payload: Promise.allSettled([
      makeAjaxRequest.postWithAuth(
        `${personDataService}/persons/id/${ctsuId}/registration/summary`
      ),
      makeAjaxRequest.fetchWithAuth(
        `${personDataService}/persons/id/${ctsuId}/registration/idme`
      )
    ]).then((response) =>
      R.compose(
        R.mergeAll,
        R.map((d) => d.value),
        R.filter((d) => d.status === 'fulfilled')
      )(response)
    )
  });
};

export const fetchPersonAddressesData = (ctepId) => async (dispatch) => {
  dispatch({
    type: FETCH_PERSON_ADDRESSES_DATA,
    payload: ctepId
      ? makeAjaxRequest
        .fetchWithAuth(
          `${process.env.REACT_APP_ORIGIN}person-data-service/v1/persons/id/${ctepId}/address`
        )
        .then((response) => {
          const a = transformBool(response);
          return a;
        })
      : Promise.resolve([])
  });
};
export const fetchPersonContactsData = (ctepId) => async (dispatch) => {
  dispatch({
    type: FETCH_PERSON_CONTACTS_DATA,
    payload: ctepId
      ? makeAjaxRequest
        .fetchWithAuth(
          `${process.env.REACT_APP_ORIGIN}person-data-service/v1/persons/id/${ctepId}/contacts`
        )
        .then((response) => transformBool(response))
      : Promise.resolve([])
  });
};
export const fetchPersonRosterRoles = (userGroup, ctepId, selectedPerson) => async (dispatch) => {
  const response = dispatch({
    type: FETCH_PERSON_ROSTER_ROLE_DATA,
    payload: makeAjaxRequest
      .postWithAuth(
        `${REACT_APP_ORIGIN}prost-data-service/v1/rosters/owner/${userGroup}/users/${ctepId}/roles`,
        {}
      )
      .then((res) => addPersonInfoToData(res, selectedPerson))
  });
  response.then(({ value }) => {
    dispatch({
      type: SET_SELECTED,
      payload: Promise.resolve({
        value: R.head(value.data || []),
        index: 0
      })
    });
  });
};

// Person affilaition
export const fetchPersonAffiliationDetails = (ctsuId) => async (dispatch) => {
  dispatch({
    type: FETCH_PERSON_AFFILIATIONS,
    payload: makeAjaxRequest
      .postWithAuth(
        `${personDataService}/persons/id/${ctsuId}/affliations/details`,
        {}
      )
      .then((response) => {
        const transformedData = transformBool(response);
        const { data } = transformedData;
        const mergedData = Array.isArray(data) && data.map((aff) => ({ ...aff, ...aff?.institutionAffiliation }));
        const sortedData = mergedData
          .slice()
          .sort(
            (a, b) =>
              new Date(b.memberRosterStatusDate) -
              new Date(a.memberRosterStatusDate)
          );
        return { ...transformedData, data: sortedData };
      })
  });
};

// Person I Button Summary API
export const fetchPersonSummary = (ctsuId) => async (dispatch) => {
  dispatch({
    type: FETCH_PERSON_SUMMARY,
    payload: makeAjaxRequest
      .fetchWithAuth(
        `${personDataService}/persons/id/${ctsuId}/info/summary`,
        {}
      )
      .then((response) => {
        const data = transformBool(response);
        return data;
      })
  });
};

export const updateUserGroup = (data) => async (dispatch) => {
  dispatch({
    type: UPDATE_USER_GROUP,
    payload: Promise.resolve(data)
  });
};

export const fetchMyTaskData = (userGroup) => async (dispatch) => {
  dispatch({
    type: FETCH_MY_TASKS,
    payload: makeAjaxRequest
      .fetchWithAuth(`${personDataService}/persons/group/${userGroup}/mytask`).then(response=> formatMyTaskData(response))
  });
};

export const fetchLmsTraningData = (ctepId) => async (dispatch) => {
  dispatch({
    type: FETCH_LMS_TRAINING_DATA,
    payload: makeAjaxRequest
      .postWithAuth(`${personDataService}/rosters/id/${ctepId}/lms`, {})
      .then((response) => {
        const data = sortByFirstItem(response.data);
        return { ...response, data };
      })
  });
};

export const saveSelectedMemberRoleStatus = (data, callback, nextRoute) => async (dispatch) => {
  const response = dispatch({
    type: SAVE_SELECTED_MEMBER_ROLE_STATUS,
    payload: Promise.resolve(data)
  });
  response.then(() => {
    callback(nextRoute);
  });
};

export const saveSelectedMemberRosterStatus = (data, callback, nextRoute) => async (dispatch) => {
  const response = dispatch({
    type: SAVE_SELECTED_MEMBER_ROSTER_STATUS,
    payload: Promise.resolve(data)
  });
  response.then(() => {
    callback(nextRoute);
  });
};

export const saveSelectedPerson = (data, callback) => async (dispatch) => {
  const ctepId = data.ctepPersonId;
  const response = dispatch({
    type: FETCH_PERSON_CONTACTS_DATA,
    payload: makeAjaxRequest
      .fetchWithAuth(
        `${process.env.REACT_APP_ORIGIN}person-data-service/v1/persons/id/${ctepId}/contacts`
      )
      .then((res) => transformBool(res))
  });

  response
    .then(({ value }) => {
      const contactInfo = R.fromPairs(
        value.map((b) => [
          b.contactType.toLowerCase().split(' ').join('_'),
          b.contact
        ])
      );
      dispatch({
        type: SAVE_SELECTED_PERSON_DATA,
        payload: Promise.resolve({ ...contactInfo, ...data })
      });
    })
    .then(() => {
      if (typeof callback === 'function') {
        callback();
      }
    });
};

export const callPassThrough = (data) => async (dispatch) => {
  const res = dispatch({
    type: CALL_PASS_THROUGH,
    payload: makeAjaxRequest.post(passThroughURL, data)
  });
  res.then((d) => {
    const html = d.value || 'not found';
    const randomNumber = Math.floor(Date.now() / 1000);
    const w = window.open('about:blank', randomNumber);
    if (w) {
      w.document.write(html);
      w.document.close();
    } else {
      console.log('unable to open link');
    }
  });
};

export const fetchPersonAttributes = (perId, infoSource, userGroup) => async (dispatch) => {
  if (!perId) {
    return;
  }
  const body = {
    ognId: perId,
    userGroup,
    infoSource,
    instRosterId: null
  };
  dispatch({
    type: FETCH_PERSON_ATTRIBUTES,
    payload: makeAjaxRequest.postWithAuth(
      `${personDataService}/persons/id/${perId}/attributes`,
      body
    )
  });
};

/**
 * Invoke api to claim the person with selected institutions.
 * @function [saveClaimPersonInformation]
 * @param {string} [method=PUT] ${process.env.REACT_APP_ORIGIN}person-data-service
 * @param {string} ctsuId - ctsu id of the selected person
 * @param {object} requestObj
 * @example
 *  requestObj = [{
        personRosterId: rosterDetails.personRosterId,
        personId: rosterDetails.personId,
        irostId: si.irostId,
        memberRosterStatus: memberRostStatus,
        memberRosterStatusDate: `${memberStatusDate}`,
        isPreferred: ia.isPreferred,
        isCtepRoster: isCtepRost === 'Yes',
        infoSource: userGroup,
        institutionAffiliation: ia,
        personCtepId: rosterDetails.personCtepId,
        siteCtepId: si.siteCtepId,
        comments
      }];
  * @see {@link https://jira.ctsu.org/browse/ROST-430|JIRA}
 */
export const saveClaimPersonInformation = (ctsuId, requestObj) =>
  // eslint-disable-next-line no-async-promise-executor, implicit-arrow-linebreak
  new Promise((resolve) => {
    const rootUrl = `${process.env.REACT_APP_ORIGIN}person-data-service`;
    makeAjaxRequest
      .putWithAuth(
        `${rootUrl}/v1/persons/id/${ctsuId}/affiliations`,
        requestObj
      )
      .then((responseObject) => {
        const err = ['Something went wrong'];
        try {
          const errorArrObj = Object.keys(responseObject).map((k, i) => {
            const resKey = Number(k);
            const rostObject = requestObj.find((o) => o.irostId === resKey);
            try {
              const parsedResp = JSON.parse(responseObject[resKey]);
              const resp = Array.isArray(parsedResp)
                ? parsedResp[0]
                : parsedResp;
              if (resp.status === 'ERROR') {
                return {
                  isError: true,
                  id: rostObject.siteCtepId,
                  message: resp.messages.map((e) => e.message)
                };
              }
              return {
                id: rostObject.siteCtepId,
                message: ['Success']
              };
            } catch (e) {
              return {
                isError: true,
                id: rostObject.siteCtepId,
                message: err
              };
            }
          });
          resolve(errorArrObj);
        } catch (e) {
          resolve([{ isError: true, id: 'Error', message: err }]);
        }
      })
      .catch((e) => {
        if (e?.message) {
          resolve([{ isError: true, id: 'Fail', message: [e.message] }]);
        }
      });
  });
export const savePersonRolesDetails = (ctsuId, requestObj) =>
  // eslint-disable-next-line no-async-promise-executor, implicit-arrow-linebreak
  new Promise(async (resolve) => {
    const rootUrl = `${process.env.REACT_APP_ORIGIN}person-data-service`;
    const responseObject = await makeAjaxRequest.putWithAuth(
      `${rootUrl}/v1/persons/id/personrosterroles`,
      requestObj
    );

    const err = ['Something went wrong'];

    try {
      if (responseObject.status !== 'success') {
        resolve([
          {
            isError: true,
            id: responseObject.status,
            message: [responseObject.messages]
          }
        ]);
      }
      resolve([
        {
          id: responseObject.status,
          message: ['Success']
        }
      ]);
    } catch (e) {
      resolve([{ isError: true, id: 'Error', message: err }]);
    }
  });
